import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { NAV_ITEMS, NavItem } from '../../core/navigation/nav-items';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [ToolbarComponent, FooterComponent, RouterModule],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  readonly navItems: NavItem[] = NAV_ITEMS.filter((i) => !i.hide);
  trackByNav = (_: number, item: NavItem) => item.route + '|' + item.label;
}
